import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import emiratescardDark from "../../../../images/emirates-card-dark.svg";
import emiratescardLight from "../../../../images/emirates-card-light.svg";
import emiratescard from "../../../../images/emiratescard.gif";
import { IkioskManager, IKioskModel } from "../../../../models/kioskModel";
import "../../Kiosk.css";

import {
  getEmiratesIdRequest,
  redirectPageAction,
} from "../../../../store/actions";

const EmiratesIdVerification: React.FC = () => {
  // Function to get the appropriate image based on body class
  const getEmiratesCard = (): string => {
    const bodyClass = document.body.className;

    // You can add more conditions based on your theme classes
    switch (true) {
      case bodyClass.includes("blue"):
        return emiratescard;
      case bodyClass.includes("dark"):
        return emiratescardDark;
      case bodyClass.includes("light"):
        return emiratescardLight;
      default:
        return emiratescard; // Default image
    }
  };
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });
  return (
    <>
      <div className="kiosk-content">
        <div className="content-sec text-center">
          <div className="insert-emirates">
            <h2>{t("Kiosk.cheersMes" + language)}</h2>
            <p>{t("Kiosk.happyMes" + language)}</p>
            <div className="emi_card">
              {" "}
              <img src={getEmiratesCard()} width="450" alt="" />
            </div>

            <p className="emi_para">
              <strong>{t("Kiosk.cardReadMes" + language)}</strong>
              <br />
              {t("Kiosk.inserCard" + language)}
            </p>
            <button
              className="btn btn-primary"
              onClick={() => dispatch(getEmiratesIdRequest())}
            >
              {t("Kiosk.scan" + language)}
            </button>

            <p className="emi_lnk">
              {t("Kiosk.noCard" + language)}
              <a style={{cursor:"pointer"}} onClick={() => dispatch(redirectPageAction(IkioskManager.MRNVERIFICATION))}>
                {" "}
                {t("Kiosk.click" + language)}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(EmiratesIdVerification);
